import React from 'react';
import MediaGallery from './MediaGallery';
import Picture from './Picture';
import { Eyebrow, sectionTitleClass } from './ui';

// sizes = tatsächliche Darstellungsbreite im Raster (Hochformat füllt die Zelle über die Breite, Querformat über die Höhe)
const IMAGES = {
  main: {
    src: '/images/Flugsportverein_Bilder_2.jpg',
    alt: 'Ultraleichtflugzeug im Flug über grünen Feldern',
    sizes: '(min-width: 1024px) 50vw, 100vw',
  },
  glider: {
    src: '/images/Flugsportverein_Bilder_7.jpg',
    alt: 'Segelflugzeug D-4414 im Tiefflug über dem Flugplatz',
    sizes: '(min-width: 1024px) 25vw, 50vw',
  },
  paramotor: {
    src: '/images/Flugsportverein_Bilder_6.jpg',
    alt: 'Motorschirm-Flieger im Abendhimmel',
    sizes: '(min-width: 1024px) 25vw, 50vw',
  },
  clouds: {
    src: '/images/Flugsportverein_Bilder_12.jpg',
    alt: 'Blick aus dem Cockpit über die Wolkendecke in die Sonne',
    sizes: '510px',
  },
  airfield: {
    src: '/images/Flugsportverein_Bilder_11.jpg',
    alt: 'Luftaufnahme des Flugplatzes Bad Langensalza mit Hangar, Segel- und Ultraleichtflugzeugen',
    sizes: '610px',
  },
};

const GridImage: React.FC<{ image: (typeof IMAGES)[keyof typeof IMAGES] }> = ({ image }) => (
  <Picture src={image.src} alt={image.alt} sizes={image.sizes} className="block h-full w-full object-cover" />
);

const MediaSection: React.FC = () => {
  return (
    <>
      <section id="impressionen" aria-labelledby="impressionen-titel" className="pt-10 lg:pt-0">
        <div className="px-5 pb-5 lg:sr-only">
          <Eyebrow>Impressionen</Eyebrow>
          <h2 id="impressionen-titel" className={sectionTitleClass}>
            Bilder vom Platz
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-0.5 bg-gray-200 lg:grid-cols-[2fr_1fr_1fr] lg:grid-rows-[380px_380px]">
          <div className="col-span-2 aspect-[16/10] lg:col-span-1 lg:row-span-2 lg:aspect-auto">
            <GridImage image={IMAGES.main} />
          </div>
          <div className="aspect-square lg:aspect-auto">
            <GridImage image={IMAGES.glider} />
          </div>
          <div className="aspect-square lg:aspect-auto">
            <GridImage image={IMAGES.paramotor} />
          </div>
          <div className="hidden lg:block">
            <GridImage image={IMAGES.clouds} />
          </div>
          <div className="hidden lg:block">
            <GridImage image={IMAGES.airfield} />
          </div>
        </div>
      </section>
      <MediaGallery />
    </>
  );
};

export default MediaSection;
